<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section id="sectionId" class="sponsors-list-wrapper d-flex body-content">
      <!--@click="onClickHandler"-->

      <div class="container-fluid left-right-common-gap">
        <!------top area start--->
        <div class="row">
          <div class="col-md-6 mb-22">
            <h1 id="headerText" class="page-head text-uppercase mb-0">
              Sponsors
            </h1>
          </div>
          <div class="col-6-md new-addendee-list">
            <div class="row justify-content-end">
              <!-- <div class="position-relative fixed-w full-width search-hld">
                 <form id="newsletter-validate-detail" class="form subscribe" action method>
                <input id="filter" type="text" placeholder="Search..." />
                <button class="sub-btn" type="submit">Subscribe</button>
                </form>
              </div>-->
              <!-----filter start---->
              <!-- <div class="dropdown">
                <button
                  class="ad-btn d-lg-inline-block dropdown-toggle"
                  type="button"
                  id="dropdownMenu2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-tag="SponsorsFilter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    height="30px"
                    viewBox="0 0 16.5 15"
                  >
                    <path
                      id="filter.svg"
                      fill="#242432"
                      d="M181.241,159.157c0,0.013,0,.025,0,0.037a0.532,0.532,0,0,1,.006.056,0.744,0.744,0,0,1-.284.583L175.25,166.3v6.453h-0.011a0.713,0.713,0,0,1-.082.366,0.747,0.747,0,0,1-1.005.3l-3.023-1.532a0.715,0.715,0,0,1-.368-0.631H170.75V166.3l-5.716-6.463a0.747,0.747,0,0,1-.284-0.584,0.523,0.523,0,0,1,.006-0.057c0-.012,0-0.023,0-0.034a0.736,0.736,0,0,1,.066-0.23c0.008-.017.017-0.033,0.027-0.05A0.722,0.722,0,0,1,165,158.7c0.007-.007.01-0.016,0.018-0.023s0.018-.008.027-0.015a0.748,0.748,0,0,1,.208-0.113l0.057-.017a0.705,0.705,0,0,1,.191-0.028h15a0.705,0.705,0,0,1,.191.028c0.02,0,.038.011,0.058,0.018a0.722,0.722,0,0,1,.206.112c0.009,0.007.02,0.008,0.028,0.015s0.011,0.016.019,0.023a0.75,0.75,0,0,1,.145.182c0.01,0.017.02,0.034,0.029,0.052A0.76,0.76,0,0,1,181.241,159.157Zm-9.172,6.377a0.716,0.716,0,0,1,.169.466h0.012v4.791l1.5,0.76V166h0.012a0.716,0.716,0,0,1,.169-0.466L178.825,160h-11.65Z"
                      transform="translate(-164.75 -158.5)"
                    />
                  </svg>
                  <span class="cart-item" style="display:none;"></span>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                  <ul class="filter-listing clearfix remember" id="dropFilter"></ul>
                </div>
              </div>-->
              <!-----filter end---->
              <div class="col-md-4 mb-3 mb-md-0 pl-md-1 comm-width-fillter-new">
                <div class="position-relative fixed-w full-width filter-hld">
                  <select>
                    <option value="All">All</option>
                    <option>Group1</option>
                    <option>Group2</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!------top area end---->
        <h3 class="text-center">
          <span id="spnHeaderText"></span>
        </h3>
        <div class="sponsors-inner-hld">
          <div id="divMainiRow">
            <!---category row start------->
            <div
              class="
                row
                attendee-list-box-wrapper
                new-sponsorlist-r
                platinum-row
              "
              v-if="priorityOneArray != undefined"
            >
              <!-------headding-->
              <div class="col-md-12">
                <h5
                  v-bind:style="
                    'border-left: 7px solid;border-color: ' +
                    priorityOneArray[0].headerLeftBarColor
                  "
                  v-bind:class="
                    'category-head ' + priorityOneArray[0].priorityCSSClass !=
                    undefined
                      ? priorityOneArray[0].priorityCSSClass
                      : ''
                  "
                >
                  {{ priorityOneArray[0].headerText }}
                </h5>
              </div>
              <!-------headding-->
              <hooper
                :itemsToShow="priorityOneitemsToShow"
                :itemsToSlide="1"
                :progress="true"
                :playSpeed="2000"
              >
                <slide
                  v-for="sponsors in priorityOneArray"
                  v-bind:key="sponsors.SponsorId"
                >
                  <router-link
                    class
                    v-bind:to="{
                      name: 'SponsorsDetailsNew',
                      params: { sid: sponsors.SponsorId },
                    }"
                    data-tag="sponsorsDetails"
                  >
                    <div class="sponsors-box-hld text-center sponsorpanel">
                      <span
                        class="logo-area"
                        data-toggle="tooltip"
                        data-html="true"
                        v-bind:title="
                          '<strong>' +
                          sponsors.Name +
                          '</strong><br />' +
                          sponsors.Website +
                          '<br />' +
                          sponsors.Level
                        "
                      >
                        <img
                          v-bind:src="sponsors.Logo"
                          v-bind:alt="sponsors.Name"
                        />
                      </span>
                    </div>
                  </router-link>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row end------->
            <!---category row start GOLD------->
            <div
              class="row attendee-list-box-wrapper new-sponsorlist-r gold-row"
              v-if="priorityTwoArray != undefined"
            >
              <!-------headding-->
              <div class="col-md-12">
                <h5
                  v-bind:style="
                    'border-left: 7px solid;border-color: ' +
                    priorityTwoArray[0].headerLeftBarColor
                  "
                  v-bind:class="
                    'category-head ' + priorityTwoArray[0].priorityCSSClass !=
                    undefined
                      ? priorityTwoArray[0].priorityCSSClass
                      : ''
                  "
                >
                  {{ priorityTwoArray[0].headerText }}
                </h5>
              </div>
              <!-------headding-->

              <hooper
                :itemsToShow="prioritytwoitemsToShow"
                :itemsToSlide="2"
                :progress="true"
                :playSpeed="2000"
              >
                <slide
                  v-for="sponsors2 in priorityTwoArray"
                  v-bind:key="sponsors2.SponsorId"
                >
                  <router-link
                    class
                    v-bind:to="{
                      name: 'SponsorsDetailsNew',
                      params: { sid: sponsors2.SponsorId },
                    }"
                    data-tag="sponsorsDetails"
                  >
                    <div class="sponsors-box-hld text-center sponsorpanel">
                      <span
                        class="logo-area"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-html="true"
                        v-bind:title="
                          '<strong>' +
                          sponsors2.Name +
                          '</strong><br />' +
                          sponsors2.Website +
                          '<br />' +
                          sponsors2.Level
                        "
                      >
                        <img
                          v-bind:src="sponsors2.Logo"
                          v-bind:alt="sponsors2.Name"
                        />
                      </span>
                    </div>
                  </router-link>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row end------->
            <!---category row start SILVER------->
            <div
              class="row attendee-list-box-wrapper new-sponsorlist-r silver-row"
              v-if="priorityThreeArray != undefined"
            >
              <!-------headding-->
              <div class="col-md-12">
                <h5
                  v-bind:style="
                    'border-left: 7px solid;border-color: ' +
                    priorityThreeArray[0].headerLeftBarColor
                  "
                  v-bind:class="
                    'category-head ' + priorityThreeArray[0].priorityCSSClass !=
                    undefined
                      ? priorityThreeArray[0].priorityCSSClass
                      : ''
                  "
                >
                  {{ priorityThreeArray[0].headerText }}
                </h5>
              </div>
              <!-------headding-->

              <hooper
                :itemsToShow="priorityThreeitemsToShow"
                :itemsToSlide="2"
                :progress="true"
                :playSpeed="2000"
              >
                <slide
                  v-for="sponsors3 in priorityThreeArray"
                  v-bind:key="sponsors3.SponsorId"
                >
                  <router-link
                    class
                    v-bind:to="{
                      name: 'SponsorsDetailsNew',
                      params: { sid: sponsors3.SponsorId },
                    }"
                    data-tag="sponsorsDetails"
                  >
                    <div class="sponsors-box-hld text-center sponsorpanel">
                      <span
                        class="logo-area"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-html="true"
                        v-bind:title="
                          '<strong>' +
                          sponsors3.Name +
                          '</strong><br />' +
                          sponsors3.Website +
                          '<br />' +
                          sponsors3.Level
                        "
                      >
                        <img
                          v-bind:src="sponsors3.Logo"
                          v-bind:alt="sponsors3.Name"
                        />
                      </span>
                    </div>
                  </router-link>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row SILVER end------->
            <!---category row start priorityFour ------->
            <div
              class="row attendee-list-box-wrapper new-sponsorlist-r silver-row"
            >
              <div class="col-md-12">
                <h5
                  v-bind:style="
                    'border-left: 7px solid;border-color: ' +
                    priorityFourArray[0].headerLeftBarColor
                  "
                  v-bind:class="
                    'category-head ' + priorityFourArray[0].priorityCSSClass
                  "
                >
                  {{ priorityFourArray[0].headerText }}
                </h5>
              </div>

              <hooper
                :itemsToShow="priorityFouritemsToShow"
                :itemsToSlide="2"
                :progress="true"
                :playSpeed="2000"
              >
                <slide
                  v-for="sponsors4 in priorityFourArray"
                  v-bind:key="sponsors4.SponsorId"
                >
                  <router-link
                    class
                    v-bind:to="{
                      name: 'SponsorsDetailsNew',
                      params: { sid: sponsors4.SponsorId },
                    }"
                    data-tag="sponsorsDetails"
                  >
                    <div class="sponsors-box-hld text-center sponsorpanel">
                      <span
                        class="logo-area"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-html="true"
                        v-bind:title="
                          '<strong>' +
                          sponsors4.Name +
                          '</strong><br />' +
                          sponsors4.Website +
                          '<br />' +
                          sponsors4.Level
                        "
                      >
                        <img
                          v-bind:src="sponsors4.Logo"
                          v-bind:alt="sponsors4.Name"
                        />
                      </span>
                    </div>
                  </router-link>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row SILVER end------->
            <!---category row start SILVER------->
            <div
              class="row attendee-list-box-wrapper new-sponsorlist-r silver-row"
            >
              <div class="col-md-12">
                <h5
                  v-bind:style="
                    'border-left: 7px solid;border-color: ' +
                    priorityFiveArray[0].headerLeftBarColor
                  "
                  v-bind:class="
                    'category-head ' + priorityFiveArray[0].priorityCSSClass
                  "
                >
                  {{ priorityFiveArray[0].headerText }}
                </h5>
              </div>

              <hooper
                :itemsToShow="priorityFiveitemsToShow"
                :itemsToSlide="2"
                :progress="true"
                :playSpeed="2000"
              >
                <slide
                  v-for="sponsors5 in priorityFiveArray"
                  v-bind:key="sponsors5.SponsorId"
                >
                  <router-link
                    class
                    v-bind:to="{
                      name: 'SponsorsDetailsNew',
                      params: { sid: sponsors5.SponsorId },
                    }"
                    data-tag="sponsorsDetails"
                  >
                    <div class="sponsors-box-hld text-center sponsorpanel">
                      <span
                        class="logo-area"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-html="true"
                        v-bind:title="
                          '<strong>' +
                          sponsors5.Name +
                          '</strong><br />' +
                          sponsors5.Website +
                          '<br />' +
                          sponsors5.Level
                        "
                      >
                        <img
                          v-bind:src="sponsors5.Logo"
                          v-bind:alt="sponsors5.Name"
                        />
                      </span>
                    </div>
                  </router-link>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row SILVER end------->
            <!---category row start SILVER------->
            <div
              class="row attendee-list-box-wrapper new-sponsorlist-r silver-row"
            >
              <div class="col-md-12">
                <h5
                  v-bind:style="
                    'border-left: 7px solid;border-color: ' +
                    prioritySixArray[0].headerLeftBarColor
                  "
                  v-bind:class="
                    'category-head ' + prioritySixArray[0].priorityCSSClass
                  "
                >
                  {{ prioritySixArray[0].headerText }}
                </h5>
              </div>

              <hooper
                :itemsToShow="prioritysixitemsToShow"
                :itemsToSlide="2"
                :progress="true"
                :playSpeed="2000"
              >
                <slide
                  v-for="sponsors6 in prioritySixArray"
                  v-bind:key="sponsors6.SponsorId"
                >
                  <router-link
                    class
                    v-bind:to="{
                      name: 'SponsorsDetailsNew',
                      params: { sid: sponsors6.SponsorId },
                    }"
                    data-tag="sponsorsDetails"
                  >
                    <div class="sponsors-box-hld text-center sponsorpanel">
                      <span
                        class="logo-area"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-html="true"
                        v-bind:title="
                          '<strong>' +
                          sponsors6.Name +
                          '</strong><br />' +
                          sponsors6.Website +
                          '<br />' +
                          sponsors6.Level
                        "
                      >
                        <img
                          v-bind:src="sponsors6.Logo"
                          v-bind:alt="sponsors6.Name"
                        />
                      </span>
                    </div>
                  </router-link>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row SILVER end------->
            <!---category row start SILVER------->
            <div
              class="row attendee-list-box-wrapper new-sponsorlist-r silver-row"
            >
              <div class="col-md-12">
                <h5
                  v-bind:style="
                    'border-left: 7px solid;border-color: ' +
                    prioritySevenArray[0].headerLeftBarColor
                  "
                  v-bind:class="
                    'category-head ' + prioritySevenArray[0].priorityCSSClass
                  "
                >
                  {{ prioritySevenArray[0].headerText }}
                </h5>
              </div>

              <hooper
                :itemsToShow="prioritysevenitemsToShow"
                :itemsToSlide="2"
                :progress="true"
                :playSpeed="2000"
              >
                <slide
                  v-for="sponsors7 in prioritySevenArray"
                  v-bind:key="sponsors7.SponsorId"
                >
                  <router-link
                    class
                    v-bind:to="{
                      name: 'SponsorsDetailsNew',
                      params: { sid: sponsors7.SponsorId },
                    }"
                    data-tag="sponsorsDetails"
                  >
                    <div class="sponsors-box-hld text-center sponsorpanel">
                      <span
                        class="logo-area"
                        data-toggle="tooltip"
                        data-placement="top"
                        data-html="true"
                        v-bind:title="
                          '<strong>' +
                          sponsors7.Name +
                          '</strong><br />' +
                          sponsors7.Website +
                          '<br />' +
                          sponsors7.Level
                        "
                      >
                        <img
                          v-bind:src="sponsors7.Logo"
                          v-bind:alt="sponsors7.Name"
                        />
                      </span>
                    </div>
                  </router-link>
                </slide>

                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row SILVER end------->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import carousel from "vue-owl-carousel";
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import db from "../components/firebaseInit";
//import TopMenu from "@/components/TopMenu.vue";
import store from "../store";
import jQuery from "jquery";
import common from "@/common";

let $ = jQuery;
var self;
export default {
  // components: { carousel },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
  data() {
    return {
      priorityOneitemsToShow: 4,
      prioritytwoitemsToShow: 4,
      priorityThreeitemsToShow: 4,
      priorityFouritemsToShow: 4,
      priorityFiveitemsToShow: 4,
      prioritysixitemsToShow: 4,
      prioritysevenitemsToShow: 4,
      //---------------------------------------
      clientID: this.$store.getters.getClient[0].id,
      SponsorPriorityCategory: [],
      // sponsorsPlatinumData: [],
      // sponsorsGoldData: [],
      // sponsorssilverData: [],
      textColor: "black",

      sponsorPriorityConst: {
        p1: "platinum-row",
        p2: "gold-row",
        p3: "silver-row",
      },
      sponsorSlideNumber: {
        PriorityOneitemsToShow: 3,
        PrioritytwoitemsToShow: 6,
        PrioritythreeitemsToShow: 8,
      },
      priorityOneArray: [],
      priorityTwoArray: [],
      priorityThreeArray: [],
      priorityFourArray: [],
      priorityFiveArray: [],
      prioritySixArray: [],
      prioritySevenArray: [],
    };
  },
  async mounted() {
    self = this;
    $('[data-toggle="tooltip"]').tooltip();
    $("div").click(function () {
      $('[data-toggle="tooltip"]').tooltip("hide");
    });
    self.priorityOneitemsToShow = 4;
    self.prioritytwoitemsToShow = 4;
    self.priorityThreeitemsToShow = 4;
    self.priorityFouritemsToShow = 4;
    self.priorityFiveitemsToShow = 4;
    self.prioritysixitemsToShow = 4;
    self.prioritysevenitemsToShow = 4;
    /*++++++++ Header color Brancing JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    //-------------dynamic font selection --------------------------------------
    if (obj.EventFont != undefined) {
      if (obj.EventFont.length > 0) {
        debugger;
        var urlpath = "";
        if (obj.EventFont[0].FontPath != "") {
          if (obj.EventFont[0].FontFamily != "") {
            urlpath = obj.EventFont[0].FontPath;

            var newStyle = document.createElement("style");
            newStyle.appendChild(
              document.createTextNode(
                "\
@font-face {\
    font-family: " +
                  obj.EventFont[0].FontFamily +
                  ";\
    src:" +
                  urlpath +
                  " ;\
}\
"
              )
            );

            document.head.appendChild(newStyle);

            $(
              "<style>* { font-family: '" +
                obj.EventFont[0].FontFamily +
                "' !important }</style>"
            ).appendTo("head");
          }
        } else {
          $("<style>* { font-family: 'Roboto' !important }</style>").appendTo(
            "head"
          );
        }
      }
    }
    //-------------dynamic font selection --------------------------------------
    //-------------------FAVICONJOB------------------------------------------------------------
    debugger;
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
    //----------------------------------------------------------------------------------

    var brandingData;
    try {
      brandingData = await self.getBrandingJSONDetails(
        obj.eventcollectionname + "/Branding/Branding.json"
      );
      if (brandingData.data != undefined) {
        if (brandingData.data.EventInfo != undefined) {
          if (brandingData.data.EventInfo.BodyTextColor != undefined) {
            self.textColor = brandingData.data.EventInfo.BodyTextColor;
          } else {
            self.textColor = "black";
          }
        } else {
          self.textColor = "black";
        }
        console.log("BodyTextColor :- " + self.textColor);
        $("#headerText").css("color", self.textColor);
      }
    } catch (e) {
      console.log("Error in Branding Json Fetch--", e);
    }
    //------------------------------------------------------------------------------
    $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    common.toggleTopMenu(true);
    common.toggleLeftMenu(true);
    //$("#topmenu").show();
    $("#btnAddUserView").click();
    if (obj.sponsordetails === true) {
      store.commit("addSponsorDetails", false);
      //lastVisible = null;
    }
    self.sponsorsData = [];
    $("#divBannerTop").css("background-color", obj.EventBranding[0].topBar);
    $("#sectionId").css(
      "background-image",
      "url(" + obj.EventBranding[0].eventBGImage + ")"
    );

    self.priorityOneArray = [];
    self.priorityTwoArray = [];
    self.priorityThreeArray = [];
    self.priorityFourArray = [];
    self.priorityFiveArray = [];
    self.prioritySixArray = [];
    self.prioritySevenArray = [];

    self.getPriorityCategoryMaster();
    self.getSponsorData();
  },
  //mounted ends
  methods: {
    getPriorityCategoryMaster() {
      // var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // console.log("EventColName : " + obj.eventcollectionname);
      // var listRef = db
      //   .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
      //   .doc("SponsorCategoryList")
      //   .collection("SponsorCategory")
      //   .orderBy("CategoryPriority")
      //   .limit(3);
      // listRef.get().then((querySnapshot) => {
      //   querySnapshot.forEach((doc) => {
      //     var data = doc.data();
      //     var spObj = new Object();
      //     spObj.CategoryID = data.CategoryID;
      //     spObj.CategoryColor = data.CategoryColor;
      //     spObj.CategoryName = data.CategoryName;
      //     self.SponsorPriorityCategory.push(spObj);
      //   });
      //   //  console.log(self.SponsorPriorityCategory);
      // });
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    getSponsorData: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      console.log("EventColName : " + obj.eventcollectionname);
      var listRef = db
        .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
        .doc("SponsorCategoryList")
        .collection("SponsorCategory")
        .orderBy("CategoryPriority");
      // .limit(3);
      var priorityCSSClass = "";
      listRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var data = doc.data();
          var spObj = new Object();
          spObj.CategoryID = data.CategoryID;
          spObj.CategoryColor = data.CategoryColor;
          spObj.CategoryName = data.CategoryName;
          spObj.CategoryPriority = data.CategoryPriority;
          spObj.LogoSize = data.LogoSize;
          self.SponsorPriorityCategory.push(spObj);
        });
        //  console.log(self.SponsorPriorityCategory);
        $.each(self.SponsorPriorityCategory, function (index, value) {
          //console.log(value.CategoryName);

          if (value.CategoryPriority == 1) {
            priorityCSSClass = self.sponsorPriorityConst.p1;

            //---------------------------------------------------
            debugger;
            if (value.LogoSize == "3X") {
              self.priorityOneitemsToShow =
                self.sponsorSlideNumber.PriorityOneitemsToShow;
            } else if (value.LogoSize == "2X") {
              self.priorityOneitemsToShow =
                self.sponsorSlideNumber.PrioritytwoitemsToShow;
            } else if (value.LogoSize == "1X") {
              self.priorityOneitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            } else {
              self.priorityOneitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            }
            //--------------------------------
          } else if (value.CategoryPriority == 2) {
            priorityCSSClass = self.sponsorPriorityConst.p2;

            //---------------------------------------------------
            debugger;
            if (value.LogoSize == "3X") {
              self.prioritytwoitemsToShow =
                self.sponsorSlideNumber.PriorityOneitemsToShow;
            } else if (value.LogoSize == "2X") {
              self.prioritytwoitemsToShow =
                self.sponsorSlideNumber.PrioritytwoitemsToShow;
            } else if (value.LogoSize == "1X") {
              self.prioritytwoitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            } else {
              self.prioritytwoitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            }
            //--------------------------------
          } else if (value.CategoryPriority == 3) {
            priorityCSSClass = self.sponsorPriorityConst.p3;

            //---------------------------------------------------
            debugger;
            if (value.LogoSize == "3X") {
              self.priorityThreeitemsToShow =
                self.sponsorSlideNumber.PriorityOneitemsToShow;
            } else if (value.LogoSize == "2X") {
              self.priorityThreeitemsToShow =
                self.sponsorSlideNumber.PrioritytwoitemsToShow;
            } else if (value.LogoSize == "1X") {
              self.priorityThreeitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            } else {
              self.priorityThreeitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            }
            //--------------------------------
          } else if (value.CategoryPriority == 4) {
            priorityCSSClass = self.sponsorPriorityConst.p3;

            //---------------------------------------------------
            debugger;
            if (value.LogoSize == "3X") {
              self.priorityFouritemsToShow =
                self.sponsorSlideNumber.PriorityOneitemsToShow;
            } else if (value.LogoSize == "2X") {
              self.priorityFouritemsToShow =
                self.sponsorSlideNumber.PrioritytwoitemsToShow;
            } else if (value.LogoSize == "1X") {
              self.priorityFouritemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            } else {
              self.priorityFouritemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            }
            //--------------------------------
          } else if (value.CategoryPriority == 5) {
            priorityCSSClass = self.sponsorPriorityConst.p3;

            //---------------------------------------------------
            debugger;
            if (value.LogoSize == "3X") {
              self.priorityFiveitemsToShow =
                self.sponsorSlideNumber.PriorityOneitemsToShow;
            } else if (value.LogoSize == "2X") {
              self.priorityFiveitemsToShow =
                self.sponsorSlideNumber.PrioritytwoitemsToShow;
            } else if (value.LogoSize == "1X") {
              self.priorityFiveitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            } else {
              self.priorityFiveitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            }
            //--------------------------------
          } else if (value.CategoryPriority == 6) {
            priorityCSSClass = self.sponsorPriorityConst.p3;

            //---------------------------------------------------
            debugger;
            if (value.LogoSize == "3X") {
              self.prioritysixitemsToShow =
                self.sponsorSlideNumber.PriorityOneitemsToShow;
            } else if (value.LogoSize == "2X") {
              self.prioritysixitemsToShow =
                self.sponsorSlideNumber.PrioritytwoitemsToShow;
            } else if (value.LogoSize == "1X") {
              self.prioritysixitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            } else {
              self.prioritysixitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            }
            //--------------------------------
          } else if (value.CategoryPriority == 7) {
            priorityCSSClass = self.sponsorPriorityConst.p3;

            //---------------------------------------------------
            debugger;
            if (value.LogoSize == "3X") {
              self.prioritysevenitemsToShow =
                self.sponsorSlideNumber.PriorityOneitemsToShow;
            } else if (value.LogoSize == "2X") {
              self.prioritysevenitemsToShow =
                self.sponsorSlideNumber.PrioritytwoitemsToShow;
            } else if (value.LogoSize == "1X") {
              self.prioritysevenitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            } else {
              self.prioritysevenitemsToShow =
                self.sponsorSlideNumber.PrioritythreeitemsToShow;
            }
            //--------------------------------
          }
          console.log("priorityCSSClass = " + priorityCSSClass);
          //---------------------------------------------------
          var listRef2 = db
            .collection(obj.eventcollectionname) //"OA_UAT_C1591205467009E1591206650065")
            .doc("SponsorList")
            .collection("Sponsors")
            .where("Category.CategoryID", "==", value.CategoryID);
          listRef2.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var data = doc.data();

              if (value.CategoryPriority == 1) {
                debugger;
                var objContent = new Object();
                objContent.priorityCSSClass =
                  priorityCSSClass != undefined ? priorityCSSClass : "";
                objContent.headerText = value.CategoryName;
                objContent.headerLeftBarColor = value.CategoryColor;

                objContent.Logo = data.Logo;
                objContent.SponsorId = data.SponsorId;
                objContent.Name = data.Name;
                objContent.Level = data.Level;
                objContent.Website = data.Website;
                self.priorityOneArray.push(objContent);
              } else if (value.CategoryPriority == 2) {
                debugger;
                var objContent2 = new Object();
                objContent2.priorityCSSClass =
                  priorityCSSClass != undefined ? priorityCSSClass : "";
                objContent2.headerText = value.CategoryName;
                objContent2.headerLeftBarColor = value.CategoryColor;

                objContent2.Logo = data.Logo;
                objContent2.SponsorId = data.SponsorId;
                objContent2.Name = data.Name;
                objContent2.Level = data.Level;
                objContent2.Website = data.Website;
                self.priorityTwoArray.push(objContent2);
              } else if (value.CategoryPriority == 3) {
                debugger;
                var objContent3 = new Object();
                objContent3.priorityCSSClass =
                  priorityCSSClass != undefined ? priorityCSSClass : "";
                objContent3.headerText = value.CategoryName;
                objContent3.headerLeftBarColor = value.CategoryColor;

                objContent3.Logo = data.Logo;
                objContent3.SponsorId = data.SponsorId;
                objContent3.Name = data.Name;
                objContent3.Level = data.Level;
                objContent3.Website = data.Website;
                self.priorityThreeArray.push(objContent3);
              } else if (value.CategoryPriority == 4) {
                var objContent4 = new Object();
                objContent4.priorityCSSClass =
                  priorityCSSClass != undefined ? priorityCSSClass : "";
                objContent4.headerText = value.CategoryName;
                objContent4.headerLeftBarColor = value.CategoryColor;

                objContent4.Logo = data.Logo;
                objContent4.SponsorId = data.SponsorId;
                objContent4.Name = data.Name;
                objContent4.Level = data.Level;
                objContent4.Website = data.Website;
                self.priorityFourArray.push(objContent4);
              } else if (value.CategoryPriority == 5) {
                var objContent5 = new Object();
                objContent5.priorityCSSClass =
                  priorityCSSClass != undefined ? priorityCSSClass : "";
                objContent5.headerText = value.CategoryName;
                objContent5.headerLeftBarColor = value.CategoryColor;

                objContent5.Logo = data.Logo;
                objContent5.SponsorId = data.SponsorId;
                objContent5.Name = data.Name;
                objContent5.Level = data.Level;
                objContent5.Website = data.Website;
                self.priorityFiveArray.push(objContent5);
              } else if (value.CategoryPriority == 6) {
                var objContent6 = new Object();
                objContent6.priorityCSSClass =
                  priorityCSSClass != undefined ? priorityCSSClass : "";
                objContent6.headerText = value.CategoryName;
                objContent6.headerLeftBarColor = value.CategoryColor;

                objContent6.Logo = data.Logo;
                objContent6.SponsorId = data.SponsorId;
                objContent6.Name = data.Name;
                objContent6.Level = data.Level;
                objContent6.Website = data.Website;
                self.prioritySixArray.push(objContent6);
              } else if (value.CategoryPriority == 7) {
                var objContent7 = new Object();
                objContent7.priorityCSSClass =
                  priorityCSSClass != undefined ? priorityCSSClass : "";
                objContent7.headerText = value.CategoryName;
                objContent7.headerLeftBarColor = value.CategoryColor;

                objContent7.Logo = data.Logo;
                objContent7.SponsorId = data.SponsorId;
                objContent7.Name = data.Name;
                objContent7.Level = data.Level;
                objContent7.Website = data.Website;
                self.prioritySevenArray.push(objContent7);
              }
            });
            console.log(self.priorityOneArray);
          });
        });
        setTimeout(() => {
          $('[data-toggle="tooltip"]').tooltip();
        }, 1000);
      });
    },
  },
  //methods ends
};
</script>